import styled, { css } from 'styled-components/macro';

const isOpenStyles = ({ theme }: any): any => css`
  background: ${theme.AccentGreen};
  border-color: ${theme.AccentGreen};
  color: #fff;
  svg {
    color: #fff;
  }
  path {
    fill: #fff !important;
  }
`;

export const SquareButton = styled.button<any>`
  transition-duration: ${({ theme }): string => theme.transitionDuration};
  background: ${({ theme }): string => theme.White};
  color: #001247;
  border: solid 1px #e8ebed;
  border-radius: 0;
  width: 40px;
  height: 40px;
  outline: none;
  display: block;
  position: relative;
  margin-left: 10px;
  cursor: pointer;

  ${({ isOpen }): any => isOpen && isOpenStyles};

  &:hover {
    color: #8da5bf;
    border-color: #0bd6a7;
    background: #f7f7f7;
  }

  &[aria-expanded='true'],
  &:active {
    ${({ isOpen }): any => isOpen && isOpenStyles};
  }
`;

export const IconWrapper = styled('div')<any>`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const OptionsWrapper = styled('ul')<any>`
  display: flex;
  flex-flow: row;
`;
